import { addMethod, array, setLocale, string } from "yup";
import { validationMessages } from "./messages";
import {
  lowercaseCharRegex,
  singleNumberMinRegex,
  specialCharRegex,
} from "./validation-pack";

const filterUndefined = (v) => v !== undefined;

setLocale({
  mixed: {
    required: validationMessages.mixed.required,
    notType: function notType(ref) {
      switch (ref.type) {
        case "number":
          return validationMessages.number.default;
        default:
          return "Invalid";
      }
    },
  },
  number: {
    positive: validationMessages.number.positive,
    integer: validationMessages.number.integer,
  },
  string: {
    email: validationMessages.string.email,
    min: ({ min }) => ({
      ...validationMessages.string.min,
      values: {
        min,
      },
    }),
    max: ({ max }) => ({
      ...validationMessages.string.max,
      values: {
        max,
      },
    }),
  },
});

/*
 * No es6 arrow function here as it retains the 'this' from
 * the enclosing lexical context
 */
addMethod(string, "password", function password(message) {
  const minLength = 6;
  return this.test("password-valid", message, function passwordTest(value) {
    if (!value) {
      return true;
    }

    if (value.length < minLength) {
      return this.createError({
        message: {
          ...validationMessages.string.min,
          values: { min: minLength },
        },
      });
    }

    if (!specialCharRegex.test(value)) {
      return this.createError({
        message: validationMessages.string.specialChar,
      });
    }

    if (!singleNumberMinRegex.test(value)) {
      return this.createError({
        message: validationMessages.string.singleNumber,
      });
    }

    if (!lowercaseCharRegex.test(value)) {
      return this.createError({
        message: validationMessages.string.lowercaseChar,
      });
    }

    return true;
  });
});

addMethod(array, "unique", function unique(message, mapper = (a) => a) {
  return this.test("unique", message, (list) => {
    const mappedList = list.map(mapper).filter(filterUndefined);
    return mappedList.length === new Set(mappedList).size;
  });
});
